import {
  AutocompleteInput,
  ChipField,
  DeleteButton,
  ReferenceArrayField,
  ReferenceArrayInput,
  SingleFieldList,
  TextField,
  useNotify,
  WithRecord,
} from "react-admin";
import { MyList } from "../../ra-lb-tools/components/myList";
import { MonetizationOnOutlined } from "@mui/icons-material";
import { MyCreate } from "../../ra-lb-tools/components/myMutator";
import { useParams } from "react-router";
import { UserField, UserInput } from "../users";
import { OrganizationField, OrganizationInput } from "./organizations";
import { MyReferencesField } from "../../ra-lb-tools/components/myReference";
import { getErrorMessage } from "../../ra-lb-tools/utils/errors";
import { Box } from "@mui/material";

export const OrganizationMemberIcon = MonetizationOnOutlined;

export const OrganizationMemberList = ({ disableDelete, ...props }) => {
  const organizationId = parseInt(useParams()["id"]);
  const notify = useNotify();

  return (
    <MyList
      resource="__organization_members"
      filter={{ organizationId }}
      forceShow={true}
      {...props}
    >
      <TextField source="id" />
      <OrganizationField source="organizationId" />
      <UserField source="userId" />
      <ReferenceArrayField source="orgRoles" reference="organization-roles">
        <SingleFieldList linkType={false}>
          <ChipField source="id" />
        </SingleFieldList>
      </ReferenceArrayField>
      {disableDelete ? null : (
        <WithRecord
          label="Delete"
          render={(om) =>
            [
              om.organization.accountOwnerId,
              om.organization.serviceAccountId,
            ].includes(om.userId) ? (
              <Box>FIXED</Box>
            ) : (
              <DeleteButton
                resource="__organization_members"
                mutationMode="pessimistic"
                redirect={false}
                mutationOptions={{
                  onError: (error) => {
                    let message = getErrorMessage(error);
                    notify(message, { type: "error" });
                  },
                }}
              />
            )
          }
        />
      )}
    </MyList>
  );
};

export const OrganizationMemberCreate = (props) => {
  return (
    <MyCreate
      permissionResource="organizations"
      permissionAction="add_member"
      {...props}
    >
      <OrganizationInput source="organizationId" disabled />
      <UserInput source="userId" />
      <ReferenceArrayInput source="orgRoles" reference="organization-roles">
        <AutocompleteInput
          filterToQuery={(searchText) => ({ id: `${searchText}` })}
          optionText="id"
          optionValue="id"
          multiple={true}
        />
      </ReferenceArrayInput>
    </MyCreate>
  );
};

export const OrganizationMemberData = (props) => {
  return (
    <OrganizationMemberList
      resource="organization-members"
      filter={null}
      disableDelete={true}
      filters={[
        <OrganizationInput
          source="organizationId"
          key="organizationId"
          alwaysOn
        />,
        <UserInput source="userId" key="userId" alwaysOn />,
      ]}
      {...props}
    />
  );
};

export const UserOrganizationMember = ({ source: _source, ...props }) => {
  return (
    <MyReferencesField
      reference="organization-members"
      target="userId"
      source="id"
      itemFormat={(v) => v.organization}
      linkResource={"organizations"}
      {...props}
    />
  );
};
